'use client';

var styles = {"MobileSelect":"MobileSelect-module_MobileSelect__U4yGA","title":"MobileSelect-module_title__2YXHC","tag":"MobileSelect-module_tag__1bafn","active":"MobileSelect-module_active__OveCq","multiple":"MobileSelect-module_multiple__13CWB","tagIcon":"MobileSelect-module_tagIcon__1w-EX","labelText":"MobileSelect-module_labelText__1LF_E"};

export { styles as default };
//# sourceMappingURL=MobileSelect.module.css.js.map
